import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface OpportunityMasterState {
  data: [] | null | any;
  currentPage: number | null;
  totalRecords: number | null;
  totalPages: number | null;
  allOpportunityMaster: [] | null | any;
}

const initialState: OpportunityMasterState = {
  data: null,
  totalRecords: null,
  totalPages: null,
  currentPage: null,
  allOpportunityMaster: null,
};

export const opportunityMasterSlice = createSlice({
  name: 'OpportunityMaster',
  initialState,
  reducers: {
    setAllOpportunityMaster: (state, action) => {
      state.allOpportunityMaster = action.payload.data;
    },
    setOpportunityMaster: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    setAllOpportunityMasterBySearch: (state, action) => {
      state.data = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords;
      state.totalPages = action.payload.data.totalPages;
      state.currentPage = action.payload.data.currentPage;
    },
    reset: () => initialState,
  },
});

export const {
  setAllOpportunityMaster,
  setOpportunityMaster,
  setAllOpportunityMasterBySearch,
  reset,
} = opportunityMasterSlice.actions;

// Selectors
export const allOpportunityMasterDetails = (state: RootState) =>
  state.opportunityMaster.allOpportunityMaster;

export const getOpportunityMasterDetails = (state: RootState) =>
  state.opportunityMaster.data;

export const getOpportunityMasterTotalRecords = (state: RootState) =>
  state.opportunityMaster.totalRecords;

export const getAllOpportunityMasterBySearch = (state: RootState) =>
  state.opportunityMaster.data;

export default opportunityMasterSlice.reducer;
